module.exports = __webpack_public_path__ + "img/google.18121477.svg";